import { callGetExternalApi, callPutExternalApi } from '../utils/externalApiCall';

// @ts-ignore
const baseURL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_BASE_CONTEXT_SII}`;

/**
 * Listado de rutas del backend
 *
 * @return {Object.<string,string>}
 */
const getBackendUrl = () => ({
  GET_CONDITIONS: `${baseURL}/public/config/download/conditions`,
  GET_COOKIES: `${baseURL}/public/config/download/cookies`,
  GET_PRIVACY: `${baseURL}/public/config/download/privacy`,
  GET_MANUAL: `${baseURL}/public/config/download/manual`,
  GET_INSTANCE: `${baseURL}/public/config?search=instance`,
  PUT_CONFIG: `${baseURL}/private/config`,
});

/**
 * @returns {Promise<*>}
 */
const getConditions = async () => callGetExternalApi({ url: getBackendUrl().GET_CONDITIONS, responseType: 'blob' });

// TODO: REVISAR ENDPOINT
/**
 * @returns {Promise<*>}
 */
const getCookies = async () => callGetExternalApi({ url: getBackendUrl().GET_COOKIES, responseType: 'blob' });

/**
 * @returns {Promise<*>}
 */
const getManual = async () => callGetExternalApi({ url: getBackendUrl().GET_MANUAL, responseType: 'blob' });

/**
 * @returns {Promise<*>}
 */
const getPrivacy = async () => callGetExternalApi({ url: getBackendUrl().GET_PRIVACY, responseType: 'blob' });

/**
 * @returns {Promise<*>}
 */
const getInstance = async () => callGetExternalApi({ url: getBackendUrl().GET_INSTANCE });

/**
 * @returns {Promise<*>}
 */
const putConfig = async ({ data }) => callPutExternalApi({ url: getBackendUrl().PUT_CONFIG, data });

export { getConditions, getCookies, getManual, getPrivacy, getInstance, putConfig };
